import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorBgBase, colorBgPrimaryLight, space1, space2, space3, space4, space6, colorTextMedium } = theme();

  return StyleSheet.create({
    basketButton: {
      marginBottom: space1,
      marginTop: space4,
    },
    darkBackground: {
      backgroundColor: colorBgPrimaryLight,
    },
    infoIcon: {
      marginRight: space2,
    },
    infoRow: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      marginTop: space3,
    },
    infoText: {
      color: colorTextMedium,
    },
    lightBackground: {
      backgroundColor: colorBgBase,
    },
    resume: {
      display: "flex",
      flexDirection: "column",
      padding: space6,
    },
    totalAmountContent: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
  });
};

export { style };
